module.exports = __webpack_public_path__ + "static/media/olake-logo-vector.45fe945c.svg";